import Vue from 'vue'
import moment from 'moment';
require('moment/locale/pt-br')

Vue.use(require('vue-moment'), {
    moment
})

export default {moment}